import * as React from 'react';
import styled from '@emotion/styled';
import Localize from 'app/src/localize/Localize';
import Format from 'app/src/data/Format';
import { Flex } from '@lightspeed/flame/Core';
import Decimal from 'app/src/data/base/Decimal';
import { Text } from '@lightspeed/flame/Text';
import { usePaymentContext } from '../Store/PaymentState';
import { Theme, StyledPaymentsPanelHeading } from '../PaymentsPanelComponent';

const StyledTotalLabel = styled.span<Theme>`
  align-self: center;
  padding-right: 10px;
  text-transform: uppercase;
`;

export const TotalPayment = () => {
  const [totalAmount, setTotalAmount] = React.useState(new Decimal(0));
  const { saleManager, paymentMethod } = usePaymentContext();

  React.useEffect(() => {
    if (paymentMethod && saleManager) {
      const pendingPaymentsTotal: Decimal = saleManager.pendingPaymentsTotal;
      if (!totalAmount.isEqualTo(pendingPaymentsTotal)) {
        setTotalAmount(pendingPaymentsTotal);
      }
    }
  }, [paymentMethod, saleManager, totalAmount]);

  return (
    <StyledPaymentsPanelHeading pt={2}>
      <Flex justifyContent="space-between">
        <StyledTotalLabel>{Localize.translate('Total')}</StyledTotalLabel>
        <Text id="total" role="listitem" data-test="total" aria-label="total">
          {Localize.getCurrencySymbol()}
          {Format.formatMoney(totalAmount, 0, false)}
        </Text>
      </Flex>
    </StyledPaymentsPanelHeading>
  );
};
